import Flex from '@Components/Bases/Flex';
import { Box, Typography } from '@mui/material';
import EsgPlatformIntroduction, {
  ESG_PLATFORM_INTRODUCTION_ID,
} from './EsgPlatformIntroduction';
import EsgPlatformRemark, { ESG_PLATFORM_REMARK_ID } from './EsgPlatformRemark';

const EsgPlatformOverview = () => {
  return (
    <Box p={2} bgcolor={'white'}>
      <Flex gap={1}>
        <Typography fontWeight={800}>
          เปิดเผยข้อมูลเกี่ยวข้องกับการปล่อยก๊าซเรือนกระจกบนระบบ SET ESG Data
          Platform
        </Typography>
        <Flex gap={0.5} alignItems={'center'}>
          <EsgPlatformIntroduction />
          <EsgPlatformRemark />
        </Flex>
      </Flex>
      <Box id={ESG_PLATFORM_INTRODUCTION_ID} />
      <Box id={ESG_PLATFORM_REMARK_ID} />
    </Box>
  );
};

export default EsgPlatformOverview;
